import type { TAxiosRequestInterceptorSuccess } from '../types';
import { ECookies } from '../../cookies';
import Cookies from 'js-cookie';
import { ENDPOINTS_WITHOUT_AUTH } from '../constants';

export const tokenInterceptor: TAxiosRequestInterceptorSuccess = config => {
  const token = Cookies.get(ECookies.TOKEN);
  const tokenType = Cookies.get(ECookies.TOKEN_TYPE);

  const isEndpointWithoutTokens = config?.url
    ? ENDPOINTS_WITHOUT_AUTH.includes(config?.url)
    : false;

  if (!token || !tokenType || isEndpointWithoutTokens) {
    return config;
  }

  config.headers.Authorization = `${tokenType} ${token}`;

  return config;
};
